'use strict';

angular.module('cgmemApp')
	.factory('Activate', function ($http, $q, User) {

		var p = null;
		var newAcct = false;
		var api = {};

		api.newActivation = function() {
			return newAcct;
		}
		
		api.set = function(n, email, token, password) {
			newAcct = n;
			p = User.reset(email, token, password);
			return;
		}	
		api.get = function() {
			if(!p)
				return $q.reject('Get before Set');
			else
				return p;
		}
		return api;
	});